/**
 * This plugin lazy load and inject loader functionality.
 *
 * @param {Object} context - special object from nuxt
 * @param {Function} inject - inject from nuxt which allow add functionality for whole app
 *
 * @return {undefined}
 */
export default function (context, inject) {
    /**
     * This function lazy load plugin and invoke method based on param type.
     *
     * @param {string} type
     * @param {Object} data
     *
     * @return {Object}
     */
    async function loaderHelper(type, data) {
        const { targetNode = document.body, ...restData } = data;

        const { default: loaderPlugin } = await import('~/src/plugins/loader' /* webpackChunkName: "lib/loader" */);
        return loaderPlugin[type]({
            ...restData,
            targetNode,
        });
    }

    inject('loader', {
        add: loaderHelper.bind(this, 'add'),
        remove: loaderHelper.bind(this, 'remove'),
        clear: loaderHelper.bind(this, 'clear'),
    });
}
